export const NBSP = '\u00A0';
export const NEW_LINE = '\u000A';
export const ROUBLE_SIGN = '\u20BD';
